module['exports'] = [
  'کتابیہ',
  'فلم',
  'گانی',
  'کھیل',
  'بجلی',
  'کمپیوٹر',
  'گھر',
  'باغ',
  'اوزار',
  'اشیاء',
  'صحر',
  'خوبصورتی',
  'کھلونہ',
  'بچے',
  'کپڑے',
  'جوتے',
  'گاڑیاں',
  'کارغانے',
];
